<template>
  <div class="connect-section__wrapper">
    <div class="connect-section__info">
      <h2 class="connect-section__title">CONNECT WITH YOUR KEY AUDIENCE</h2>

      <p class="connect-section__description text-body">
        Finance Magnates Group: Your Hub for Expert Financial Advertising and
        Insights. Our platform excels in delivering the latest financial news,
        market trends, and premium content. Tailored for the financial industry,
        we offer robust solutions for advertisers to craft influential campaigns
        that engage a financially astute audience. With our focus on data-driven
        strategies and secure, reputable environments.
      </p>
    </div>

    <a-responsive
      class="connect-section__icon-wrapper"
      :aspect-ratio="$options.consts.ASPECT_RATIO.EARTH_ICON"
    >
      <a-icon
        :icon="$options.consts.ICON.CONNECT_WITH_YOUR_KEY_AUDIENCE"
        width="auto"
        height="auto"
        :no-hover="true"
        :original="true"
        class="connect-section__icon"
      />
    </a-responsive>
  </div>
</template>

<script>
import AIcon, { ICON } from 'shared/AIcon/index.vue'
import AResponsive from 'shared/AResponsive/index.vue'
import { ASPECT_RATIO } from 'enums/aspectRatios'
import { generateServerCacheKey } from '@/plugins/helper'

export default {
  name: 'HomepageConnectSection',
  serverCacheKey: () => generateServerCacheKey('HomepageConnectSection'),
  components: { AResponsive, AIcon },
  consts: {
    ICON,
    ASPECT_RATIO
  }
}
</script>

<style lang="scss" scoped>
@import '~assets/scss/local/mixins/grid';

.connect-section__wrapper {
  position: relative;

  $grid-setup: (
    $columnSetup: (
      $above-desktop-xl: percentage(750px / $desktop-full-hd-container)
        percentage(516px / $desktop-full-hd-container),
      $desktop-sm: percentage(401px / $tablet-container)
        percentage(315px / $tablet-container),
      $mobile: percentage(246px / $mobile-container)
        percentage(208px / $mobile-container)
    ),
    $columnGapSetup: (
      $above-desktop-xl: 69px,
      $desktop-sm: 26px,
      $mobile: 8px
    )
  );

  @include gridBuilder($grid-setup);

  .connect-section__info {
    $margin-top: (
      $above-desktop-xl: 158px,
      $desktop-sm: 88px,
      $mobile: 39px
    );

    @include setStyleByBreakpoint('margin-top', $margin-top);
  }

  .connect-section__title {
    @include mobile {
      width: 290px;
    }
  }

  .connect-section__description {
    $margin-top: (
      $above-desktop-xl: 60px,
      $desktop-sm: 26px,
      $mobile: 15px
    );

    $margin-bottom: (
      $above-desktop-xl: 50px,
      $desktop-sm: 45px,
      $mobile: 40px
    );

    @include setStyleByBreakpoint('margin-top', $margin-top);
    @include setStyleByBreakpoint('margin-bottom', $margin-bottom);
  }

  .connect-section__icon-wrapper {
    position: relative;

    $margin-bottom: (
      $desktop-sm: 30px
    );

    @include setStyleByBreakpoint('margin-bottom', $margin-bottom);
  }

  .connect-section__icon {
    position: relative;

    @include desktop-sm {
      top: 15px;
    }

    @include mobile {
      top: 60px;
      width: 100%;
    }

    @media (min-width: 420px) and (max-width: $mobile) {
      top: -20px;
    }
  }
}
</style>
